import styles from '../../assets/styles/GeneralNotification/GeneralNotification.module.scss';
import { MimaText, NotificationModal } from '../../components';
import React from 'react';
import InfoImg from '../../assets/img/Vector-e.png';

const GeneralNotification = ({
	closeModal,
	notifications,
	handleReadAll,
	handleReadOne,
}) => {
	return (
		<NotificationModal closeModal={closeModal}>
			<div className={styles.container_top}>
				<MimaText variant="subtitleBold">Notifications</MimaText>
				<div className={styles.readAll} onClick={handleReadAll}>
					Mark all as read
				</div>
			</div>
			{notifications?.map((notification, index) => {
				return (
					<div
						key={index}
						className={styles.container_row}
						onClick={() => {
							handleReadOne({ Id: notification?._id });
						}}>
						<div className={styles.iconWrapper}>
							<img
								src={InfoImg}
								alt="Notification icon"
								className={styles.icon}
							/>
						</div>
						<div>
							<MimaText variant="bodyBold" mb={0.5}>
								{notification?.title}
							</MimaText>
							<MimaText mb={0.5}>{notification?.description}</MimaText>
							<MimaText variant="small">{notification?.timeAgo}</MimaText>
						</div>
						{notification.read.toString() === 'false' ? (
							<div className={styles.container_read}></div>
						) : null}
					</div>
				);
			})}
		</NotificationModal>
	);
};

export default GeneralNotification;
